export default __webpack_public_path__ + "static/media/signup.5cb3cf60.png";